import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const AcceptDialog = ({ handleClose, dialogContentText, dialogTitle, handleAccept, open }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={open}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle
        id="responsive-dialog-title"
        sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.25rem' }}
      >
        {dialogTitle}
      </DialogTitle>

      <DialogContent>
        <DialogContentText
          sx={{
            textAlign: 'center',
            fontSize: '1rem',
            wordBreak: 'break-word',
            whiteSpace: 'pre-wrap',
            padding: '10px'
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: dialogContentText }} />
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', paddingBottom: 2 }}>
        <Button
          onClick={handleAccept}
          variant="contained"
          autoFocus
          sx={{
            backgroundColor: '#1976D2',
            color: 'white',
            fontWeight: 'bold',
            '&:hover': {
              backgroundColor: '#115293'
            },
            mr: 1
          }}
        >
          Aceptar
        </Button>
        <Button
          onClick={handleClose}
          variant="outlined"
          color="secondary"
        >
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AcceptDialog;
